export default "__VITE_ASSET__BjOAeIPK__"